module.exports = {
	layouts: {
		home: Vue.component('home', require('./components/layouts/Home.vue').default)
	},

	global: {
		field: Vue.component('field', require('./components/global/Field.vue').default),
		triggerPopup: Vue.component('trigger-popup', require('./components/global/TriggerPopup.vue').default)
	}
};
